import { render, staticRenderFns } from "./AddOrganisation.vue?vue&type=template&id=19c0c0f4&"
import script from "./AddOrganisation.vue?vue&type=script&lang=js&"
export * from "./AddOrganisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports